require('./countries-form.scss')

module.exports = {
  template: require('./countries-form.pug')()
  controller: require('./countries-form.ctrl')
  bindings:
    country: '<'
    onSubmit: '&'
}
